import React, { useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import { academydetail } from "../service/dashboard";
import { useNavigate } from "react-router-dom";

const About = () => {
    const navigate=useNavigate();
    const [adetail, setADetail] = useState("");
    const [apath, setAPath] = useState("");
    useEffect(() => {
        academydetail(localStorage.getItem("academy")).then((res)=>{
            if(res.status === true){
                setADetail(res.data.details);
                setAPath(res.data.path);
            }
        })
    },[]);

    function errorhandle(ev) {
    ev.target.src = require("../assets/images/logo/tracking-logo.png");
    ev.target.onerror = null;
  }
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="contact-container" id="about">
                    <div className="header" onClick={() => navigate("/more")}>
                        <i className="fas fa-arrow-left back-icon"></i>
                        <h3>About School</h3>
                    </div>

                    <div className="profile-icon">
                        <div className="mb-3">
                            {/* <i className="fas fa-users"></i> */}
                            <img src={apath + adetail.logo} alt="dash-logo" onError={errorhandle} width={"150px"} height={"150px"}/>
                        </div>
                    </div>

                    <div className="contact-buttons">
                        <div className="icon-button"><i className="fas fa-phone"></i></div>
                        <div className="icon-button"><i className="fas fa-comment-dots"></i></div>
                        <div className="icon-button"><i className="fas fa-envelope"></i></div>
                    </div>

                    <div className="contact-info">
                        <h4>Contact Information</h4>
                        <p><strong>Website</strong>: {adetail?.website}</p>
                        <p><strong>Email</strong>: {adetail?.email}</p>
                        <p><strong>Phone</strong>: {adetail?.phone}</p>
                        <p><strong>Address</strong>: {adetail?.address}</p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default About;
